export const FETCH_RESOURCE_CLEANUP_DETAILS = 'FETCH_RESOURCE_CLEANUP_DETAILS';
export const FETCH_RESOURCE_CLEANUP_DETAILS_SUCCESS = 'FETCH_RESOURCE_CLEANUP_DETAILS_SUCCESS';
export const FETCH_RESOURCE_CLEANUP_DETAILS_FAILED = 'FETCH_RESOURCE_CLEANUP_DETAILS_FAILED';
export const SET_SEARCH_RESOURCE_CLEANUP = 'SET_SEARCH_RESOURCE_CLEANUP';

export const FETCH_RESOURCE_FILE_DETAILS = 'FETCH_RESOURCE_FILE_DETAILS';
export const FETCH_RESOURCE_FILE_DETAILS_SUCCESS = 'FETCH_RESOURCE_FILE_DETAILS_SUCCESS';
export const FETCH_RESOURCE_FILE_DETAILS_FAILED = 'FETCH_RESOURCE_FILE_DETAILS_FAILED';
export const SET_SEARCH_RESOURCE_FILE = 'SET_SEARCH_RESOURCE_FILE';

export const VALIDATE_FILE = 'VALIDATE_FILE';
export const VALIDATE_FILE_SUCCESS = 'VALIDATE_FILE_SUCCESS';
export const VALIDATE_FILE_FAILED = 'VALIDATE_FILE_FAILED';

export const PROCESS_CLEANUP = 'PROCESS_CLEANUP';
export const PROCESS_CLEANUP_SUCCESS = 'PROCESS_CLEANUP_SUCCESS';
export const PROCESS_CLEANUP_FAILED = 'PROCESS_CLEANUP_FAILED';
export const UPDATE_PROCESS_CLEANUP_RESPONSE = 'UPDATE_PROCESS_CLEANUP_RESPONSE';

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAILED = 'DOWNLOAD_FILE_FAILED';

export const DELETE_FILE = 'DELETE_FILE';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILED = 'DELETE_FILE_FAILED';

export const fetchResourceCleanupDetails = (payload) => ({
  type: FETCH_RESOURCE_CLEANUP_DETAILS,
  payload,
});

export const fetchResourceCleanupDetailsSuccess = (payload) => ({
  type: FETCH_RESOURCE_CLEANUP_DETAILS_SUCCESS,
  payload,
});

export const fetchResourceCleanupDetailsFailed = (payload) => ({
  type: FETCH_RESOURCE_CLEANUP_DETAILS_FAILED,
  payload,
});

export const setsearchresourcecleanup = (payload) => ({
  type: SET_SEARCH_RESOURCE_CLEANUP,
  payload,
});
//----------------------------File details----------------------------
export const fetchResourceFileDetails = (payload) => ({
  type: FETCH_RESOURCE_FILE_DETAILS,
  payload,
});

export const fetchResourceFileDetailsSuccess = (payload) => ({
  type: FETCH_RESOURCE_FILE_DETAILS_SUCCESS,
  payload,
});

export const fetchResourceFileDetailsFailed = (payload) => ({
  type: FETCH_RESOURCE_FILE_DETAILS_FAILED,
  payload,
});

export const setsearchresourceFile = (payload) => ({
  type: SET_SEARCH_RESOURCE_FILE,
  payload,
});

//--------------------validate file----------------
export const validateFile = (payload) => ({
  type: VALIDATE_FILE,
  payload,
});

export const validateFileSuccess = () => ({
  type: VALIDATE_FILE_SUCCESS,
});

export const validateFileFailed = () => ({
  type: VALIDATE_FILE_FAILED,
});

//--------------------process cleanup----------------
export const processCleanup = (payload) => ({
  type: PROCESS_CLEANUP,
  payload,
});

export const processCleanupSuccess = () => ({
  type: PROCESS_CLEANUP_SUCCESS,
});

export const processCleanupFailed = () => ({
  type: PROCESS_CLEANUP_FAILED,
});

export const updateProcessCleanupResponse = (payload) => ({
  type: UPDATE_PROCESS_CLEANUP_RESPONSE,
  payload,
});

//-----------------------download file-------------------
export const downloadFile = (payload) => ({
  type: DOWNLOAD_FILE,
  payload,
});

export const downloadFileSuccess = () => ({
  type: DOWNLOAD_FILE_SUCCESS,
});

export const downloadFileFailed = () => ({
  type: DOWNLOAD_FILE_FAILED,
});

//-----------------------download file-------------------
export const deleteFile = (payload) => ({
  type: DELETE_FILE,
  payload,
});

export const deleteFileSuccess = () => ({
  type: DELETE_FILE_SUCCESS,
});

export const deleteFileFailed = () => ({
  type: DELETE_FILE_FAILED,
});
